import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { TimesheetCreate } from '../models/timesheet-create';
import { TimesheetResult } from '../models/timesheet-result';
import { BaseApiService } from './base-api.service';

@Injectable({
  providedIn: 'root',
})
export class TimesheetService {
  private baseApiService = inject(BaseApiService);

  private urlBase: string = 'api/timesheets';

  createTimesheet(timesheetModel: TimesheetCreate): Observable<TimesheetResult> {
    const formData = new FormData();
    Object.entries(timesheetModel).forEach(([k, v]) =>
      formData.append(k, v instanceof File ? v : String(v)),
    );
    return this.baseApiService.save<TimesheetResult>(this.urlBase, formData);
  }
}
